import Api from '../api';
import jwt_decode from 'jwt-decode';

export default class AuthApi extends Api {
  // ! On Login
  onLogin = async payload => {
    try {
      const apiData = await this.post('/', payload);
      const { data } = apiData;
      console.log({ data });
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to get account details'
      };
    }
  };

  // ! On check Login
  async onCheckLogin() {
    try {
      const accessToken = this.getAccessToken();
      if (accessToken) {
        const decodedToken = jwt_decode(accessToken);
        const d = this.onExtractUserData(decodedToken);
        this.setUser(d);
      }
      const isTokenStillAlive = await this.isTokenAlive();
      return isTokenStillAlive;
    } catch (error) {
      console.log('Error while validate session token', error);
    }
    return false;
  }

  // ! On extract user data
  onExtractUserData(loginPayload) {
    const payload = {
      show_business_overview: true,
      sourceName: ['web'],
      ...loginPayload
    };
    return payload;
  }

  // ! On get account details
  getAccountDetails = async () => {
    try {
      const apiData = await this.get('linkedAccount/');
      return apiData;
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to get account details'
      };
    }
  };

  getSubUserMenu = async userId => {
    try {
      return await this.get(`userPreferences/menu?userID=${userId}`);
    } catch (error) {
      return {
        hasError: true,
        error: error,
        customMessage: 'Fail to get user menu'
      };
    }
  };
}
